import { Component, ElementRef, HostListener, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { Observable, map, of } from "rxjs";

import { GurdServiceService } from "src/app/Service/gurd-service.service";

import { Tile } from "ol/layer";

import OSM from 'ol/source/OSM';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import Map from 'ol/Map';

import { MapService } from "src/app/Service/map.service";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import { Point } from "ol/geom";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";

declare let $: any;

@Component({

  selector: 'app-monitoring-dashboard',

  templateUrl: './monitoring-dashboard.component.html',

  styleUrls: ['./monitoring-dashboard.component.css']

})

export class MonitoringDashboardComponent implements OnInit {

  iMobileDomain: string = '-1';

  ctxChart: any;

  ctxChart2: any;

  ctxChart3: any;

  ctxChart4: any;

  ctxChart5: any;

  options!: Observable<any>;

  schoolMap: any;

  source: any;

  vector: any;

  layers: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  CHART_COLORS: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };

  constructor(

    private router: Router,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private mapService: MapService,



  ) {

    Chart.register(zoomPlugin);

  }

  ngOnInit(): void {

    this.getCharts();

  }

  async getCharts() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    this.ticket_ChartBase(model);

    this.ticket_BaseSubject(model);

    this.ticket_BaseStatus(model);

    this.mobileDomainCluster(model);

  }

  async ticket_ChartBase(model: any) {

    let res = JSON.parse(((await axios.post(`Report_MobileCountBaseMobileDomain`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart1') as any;

    if (this.ctxChart) this.ctxChart.destroy();

    this.ctxChart = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });



  }

  async ticket_BaseSubject(model: any) {

    let res = JSON.parse(((await axios.post(`MonitoringDashboard_SchoolCountBaseMobileDomain`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart2') as any;

    if (this.ctxChart2) this.ctxChart2.destroy();

    this.ctxChart2 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async ticket_BaseStatus(model: any) {

    let res = JSON.parse(((await axios.post(`MonitoringDashboard_PassengerCountBaseMobileDomain`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart3') as any;

    if (this.ctxChart3) this.ctxChart3.destroy();

    this.ctxChart3 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async mobileDomainCluster(model: any) {

    let res = JSON.parse(((await axios.post(`School_MobileDomainCluster`, model)).data.toString()));

    setTimeout(() => {

      if (this.schoolMap) this.schoolMap.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }


      this.schoolMap = new Map({

        target: "map1",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers

      });

      this.clustersLayer(res, model);

    }, 500);





  }

  async clustersLayer(data: any, model: []) {

    setTimeout(() => {

      this.schoolMap.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(

          this.schoolMap.getEventPixel(e.originalEvent),

          this.schoolMap
        );

        this.Notification.showInfo(`نام مدرسه : ${el.featureLayer.feature.values_.features[0].values_.data.strComment}`, '')

        $("#link").click(() => {

          var tooltip = $('#map_tooltip');

          tooltip.tooltip('hide');

        });

      });

      this.schoolMap.getView().on('propertychange', function (e: any) {

        var tooltip = $('#map_tooltip');

        tooltip.tooltip('hide');

      });

    }, 200);



    var clusterSource = new Cluster({

      distance: 40,

      source: new Vector()

    }) as any;


    let addFeatures = (nb: any) => {

      var ext = this.schoolMap.getView().calculateExtent(this.schoolMap.getSize());

      var features = [];

      for (var i = 0; i < data.length; ++i) {

        features[i] = new Feature({

          type: 'removable',

          geometry: new Point(this.mapService.transformCoordinates2([

            data[i].dLongitude,

            data[i].dLatitude])

          ),

          id_: data[i].strUnitId,

          data: { strComment: data[i].strComment, },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.schoolMap.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.schoolMap.addInteraction(selectCluster);


  }

}
